import { Icon } from '@iconify/react'
import { Container, Reveal } from '@/components/ui'
import { SITE } from '@/content/site'
import { useSlotT } from '@/cms/useSlotT'

export default function CtaBanner() {
  // 2026-11-04: the banner moved off the homepage onto /products (it
  // replaced that page's 定制化支援服務 band), so its copy is edited under
  // the 產品頁 scope now. The i18n keys stay `home.cta.*` — see the note in
  // SupportProcess.tsx.
  const slotT = useSlotT('products')

  return (
    <section
      className="relative py-section-y px-section-x bg-gradient-to-br from-primary via-primary-dark to-yada-olive text-surface overflow-hidden"
      aria-labelledby="cta-title"
    >
      {/* Decorative shapes */}
      <div aria-hidden="true" className="absolute top-0 right-0 w-96 h-96 bg-accent/20 rounded-full blur-3xl" />
      <div aria-hidden="true" className="absolute bottom-0 left-0 w-96 h-96 bg-yada-gold/20 rounded-full blur-3xl" />

      <Container className="relative z-10">
        <Reveal>
          <div className="text-center max-w-3xl mx-auto">
            <h2
              id="cta-title"
              className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-3 md:mb-4 leading-tight text-balance"
            >
              {slotT('home.cta.title')}
            </h2>
            <p className="text-base md:text-xl text-surface/90 mb-6 md:mb-8 text-pretty">
              {slotT('home.cta.text')}
            </p>
            <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-3">
              <a
                href={SITE.contact.whatsapp.link}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 bg-accent text-ink px-5 py-3 md:px-8 md:py-4 rounded-yada-full hover:bg-accent-soft transition-all hover:-translate-y-0.5 text-sm md:text-base font-semibold shadow-yada-lg"
              >
                <Icon icon="lucide:message-circle" style={{ fontSize: '1.25rem' }} />
                <span>{slotT('home.cta.button')}</span>
              </a>
              <a
                href={`mailto:${SITE.contact.email.display}`}
                className="inline-flex items-center justify-center gap-2 bg-transparent text-surface border-2 border-surface px-5 py-3 md:px-8 md:py-4 rounded-yada-full hover:bg-surface hover:text-primary transition-all text-sm md:text-base font-semibold"
              >
                <Icon icon="lucide:mail" style={{ fontSize: '1.25rem' }} />
                {/* Phase 1 mobile (2026-10-13): the previous label was the
                    full email address (e.g. hello@yada.hk), which on a
                    360px viewport overflowed the pill border. Use the
                    i18n slot for a short "Email us" label, with the
                    actual address still discoverable via the mailto: href. */}
                <span>{slotT('home.cta.emailCta')}</span>
              </a>
            </div>
          </div>
        </Reveal>
      </Container>
    </section>
  )
}
